import { StyledAccordionHeading } from '../VerticalAccordion/VerticalAccordion.styles.mjs';
import styled from 'styled-components';

const Container = styled.div `
  box-sizing: border-box;
  width: 100%;
  background-color: ${props => props.theme.colors.backgroundColor};
  padding: 1.5rem 1rem 2.25rem;

  @media screen and (min-width: ${props => props.theme.breakpoints.lg}) {
    column-count: 3;
    padding: 2.625rem 3.75rem 2.3125rem;
  }

  @media screen and (max-width: ${props => props.theme.breakpoints.lg}) {
    padding-top: 1.25rem;
    padding-bottom: 0;
    display: flex;
    flex-direction: column;
    gap: 2.25rem;
  }
`;
const SectionWrapper = styled.div `
  break-inside: avoid;

  ${StyledAccordionHeading} {
    h3 {
      font-size: 1.125rem;
      line-height: 1.438rem;
      margin: 0;
    }
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.lg}) {
    max-width: 240px;

    h3 {
      margin: 0 0 0.625rem;
    }

    ul {
      margin-bottom: 2rem;
    }
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.max}) {
    max-width: unset;
  }
`;

export { Container, SectionWrapper };
//# sourceMappingURL=MenuContent.styles.mjs.map
